import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Class10ReadingInstruction = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const target = location.state?.target;

    const handleStartTest = () => {
        if (target) {
          navigate(target);
        } else {
          console.error("No target provided!");
        }
    };

    return (
        <div className="min-h-screen bg-[#D7DFEC]">
            {/* Logos Row */}
            <div className="w-full flex flex-row items-center justify-between py-4 px-8 bg-white">
                <img src="/Logos/IELTSlogo.png" alt="IELTS Logo" className="h-12 object-contain transform scale-90" />
                <img src="/Logos/HEXASLogo.jpg" alt="Hexas Logo" className="h-14 object-contain" />
                <img src="/Logos/CambridgeAssessmentLogo.png" alt="IELTS Partners" className="h-14 object-contain transform scale-125" />
                <img src="/Logos/BritishCouncilLogo.png" alt="IELTS Partners" className="h-12 object-contain" />
                <img src="/Logos/IDPLogo.png" alt="IELTS Partners" className="h-12 object-contain" />
            </div>

            {/* Top Bar */}
            <div className="relative h-[32px] bg-gray-800 border-b border-gray-700 flex items-center justify-between px-4 overflow-hidden">
                {/* White soft highlighter effect */}
                <div
                    className="absolute pointer-events-none"
                    style={{
                        top: '10%',
                        bottom: '10%',
                        left: 0,
                        right: 0,
                        background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.18) 50%, rgba(255,255,255,0) 100%)',
                        backdropFilter: 'blur(6px)',
                        zIndex: 0,
                    }}
                ></div>

                {/* Left: User Info */}
                <div className="w-1/3 flex items-center z-10">
                    <span className="text-[12px] text-[#CCCCCC] font-medium">
                        <span className="mr-1">👤</span>
                        Saikat - 267733
                    </span>
                </div>
            </div>

            {/* Main content */}
            <div className="w-full px-4 py-6 flex justify-center">
                <div className="bg-[#E3E9F0] rounded border border-[#A0A9B8] shadow-sm p-6 w-full -mt-3 -mx-10 max-w-[1600px] h-[400px]">
                    <h1 className="text-[20px] font-bold text-black mb-4">
                        IELTS Reading
                    </h1>

                    <div className="space-y-3 text-left">
                        <div>
                            <p className="text-black text-[14px]">Time: 60 minutes</p>
                        </div>

                        <div>
                            <h2 className="text-[16px] font-bold text-black mb-2">
                                INSTRUCTIONS TO CANDIDATES
                            </h2>
                            <ul className="list-disc pl-6 space-y-0.5 text-black text-[14px]">
                                <li>Answer <span className="font-bold">all</span> the questions.</li>
                                <li>You can change your answers at any time during the test.</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-[16px] font-bold text-black mb-2">
                                INFORMATION FOR CANDIDATES
                            </h2>
                            <ul className="list-disc pl-6 space-y-0.5 text-black text-[14px]">
                                <li>There are 40 questions in this test.</li>
                                <li>Each question carries one mark.</li>
                                <li>There are 3 passages to read.</li>
                                <li>You will have 60 minutes to complete the test.</li>
                                <li>For each passage, you will have time to read and answer the questions.</li>
                            </ul>
                        </div>
                    </div>

                    {/* Footer Note & Start Button */}
                    <div className="pt-3 flex flex-col items-center">
                        <button
                            onClick={handleStartTest}
                            className="bg-[#F8F9FA] font-semibold text-black px-5 py-1.5 rounded text-[13px] border border-[#A0A9B8] hover:bg-[#F0F2F4] transition-colors shadow-sm"
                        >
                            Start test
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Class10ReadingInstruction; 